<template>
    <v-menu
        :key="menuKey"
        :model-value="open"
        location="bottom start"
        offset="6"
        :close-on-content-click="false"
        :scrim="false"
        @update:model-value="onOpenChange"
    >
        <template #activator="{ props: menuProps }">
            <span v-if="variant === 'ware-button'" class="d-inline-flex">
                <v-btn
                    v-bind="menuProps"
                    size="default"
                    color="yellow"
                    variant="outlined"
                    data-cy="entries-floor-area-menu-button"
                    @click.stop
                >
                    <template v-if="appliedFloorAreaLabel">
                        {{ $t("entries.floorAreaUnit") }}:&nbsp;{{ appliedFloorAreaLabel }}
                    </template>
                    <template v-else>
                        {{ $t("entries.floorAreaCalculator") }}
                    </template>
                </v-btn>
                <v-tooltip activator="parent" location="bottom">
                    {{
                        appliedFloorAreaLabel
                            ? $t("entries.floorAreaAppliedTooltip")
                            : $t("entries.floorAreaCalculatorTooltip")
                    }}
                </v-tooltip>
            </span>

            <span v-else class="d-inline-flex">
                <v-btn
                    v-bind="menuProps"
                    density="compact"
                    color="primary"
                    variant="flat"
                    data-cy="publish-floor-area-menu-button"
                    @click.stop
                >
                    <template v-if="appliedFloorAreaLabel">
                        {{ $t("entries.floorAreaUnit") }}:&nbsp;{{ appliedFloorAreaLabel }}
                    </template>
                    <template v-else>
                        {{ $t("entries.floorAreaCalculator") }}
                    </template>
                </v-btn>
                <v-tooltip activator="parent" location="bottom">
                    {{
                        appliedFloorAreaLabel
                            ? $t("entries.floorAreaAppliedTooltip")
                            : $t("entries.floorAreaCalculatorTooltip")
                    }}
                </v-tooltip>
            </span>
        </template>

        <FloorAreaPanel
            ref="panel"
            :length-cm="lengthCm"
            :width-cm="widthCm"
            :package-count="packageCount"
            @update:length-cm="$emit('update:lengthCm', $event)"
            @update:width-cm="$emit('update:widthCm', $event)"
            @update:package-count="$emit('update:packageCount', $event)"
            @apply="$emit('apply', $event)"
        />
    </v-menu>
</template>

<script>
import FloorAreaPanel from "./FloorAreaPanel.vue";

export default {
    name: "FloorAreaMenu",
    components: {
        FloorAreaPanel,
    },
    props: {
        entry: {
            type: Object,
            default: null,
        },
        open: {
            type: Boolean,
            default: false,
        },
        lengthCm: {
            type: [String, Number],
            default: "",
        },
        widthCm: {
            type: [String, Number],
            default: "",
        },
        packageCount: {
            type: [String, Number],
            default: "1",
        },
        appliedFloorAreaLabel: {
            type: String,
            default: "",
        },
        variant: {
            type: String,
            default: "toolbar-button",
            validator: (value) => ["toolbar-button", "ware-button"].includes(value),
        },
    },
    emits: [
        "update:open",
        "update:lengthCm",
        "update:widthCm",
        "update:packageCount",
        "apply",
    ],
    computed: {
        menuKey() {
            const entryUid = this.entry?.uid ?? "publish";
            return `floor-area-${entryUid}-${this.variant}`;
        },
    },
    methods: {
        onOpenChange(open) {
            if (!open) {
                requestAnimationFrame(() => {
                    if (this.$refs.panel?.shouldSuppressCloseApply?.()) {
                        this.$emit("update:open", true);
                        return;
                    }

                    const panelEl = this.$refs.panel?.$el;
                    if (panelEl?.contains(document.activeElement)) {
                        this.$emit("update:open", true);
                        return;
                    }
                    this.$refs.panel?.tryApply();
                    this.$emit("update:open", false);
                });
                return;
            }
            this.$emit("update:open", open);
        },
    },
};
</script>
